import { FC } from "react";
import { useSearchParams } from "react-router-dom";
import useI18n from "../../../../hooks/useTranslations";
import Tabs, { Tab } from "../../../ui/Tabs";
import { ItemExtras } from "./itemExtras/ItemExtras";
import LabelLanguages from "./labelLanguages/LabelLanguages";
import RailCurves from "./railCurves/RailCurves";
import RailJunctions from "./railJunctions/RailJunctions";
import Rails from "./rails/Rails";
import RailTerminals from "./railTerminals/RailTerminals";
import Screws from "./screws/Screws";
import Substructures from "./substructures/Substructures";
import Supports from "./supports/Supports";
import Systems from "./systems/Systems";
import Tools from "./tools/Tools";
import Towers from "./towers/Towers";
import Trolleys from "./trolleys/Trolleys";
import WaterproofKits from "./waterproofKits/WaterproofKits";
import WorkMethods from "./workMethods/WorkMethods";

const HRailSettings: FC = () => {
  const i18n = useI18n();
  const [searchParams] = useSearchParams();
  const selectedIndex = Number(searchParams.get("tab")) || 0;
  const tabs: Tab[] = [
    { title: i18n.translation.systems.plural },
    { title: i18n.translation.workMethods.plural },
    { title: i18n.translation.substructures.plural },
    { title: i18n.translation.supports.plural },
    { title: i18n.translation.labelLanguages.plural },
    { title: i18n.translation.items.plural, hasSubTabs: true },
  ];

  return (
    <Tabs
      urlParameter="tab"
      tabs={tabs}
      contents={[
        <Systems active={selectedIndex === 0} />,
        <WorkMethods active={selectedIndex === 1} />,
        <Substructures active={selectedIndex === 2} />,
        <Supports active={selectedIndex === 3} />,
        <LabelLanguages active={selectedIndex === 4} />,
        <ItemSettings active={selectedIndex === 5} />,
      ]}
    />
  );
};

export default HRailSettings;

type SubTabsProps = {
  active?: boolean;
};

const ItemSettings: FC<SubTabsProps> = ({ active }) => {
  const i18n = useI18n();
  const [searchParams] = useSearchParams();
  const selectedIndex = Number(searchParams.get("h_items")) || 0;
  const tabs: Tab[] = [
    { title: i18n.translation.towers.plural },
    { title: i18n.translation.trolleys.plural },
    { title: i18n.translation.waterproofKits.plural },
    { title: i18n.translation.rails.plural },
    { title: i18n.translation.railCurves.plural },
    { title: i18n.translation.railJunctions.plural },
    { title: i18n.translation.railTerminals.plural },
    { title: i18n.translation.screws.plural },
    { title: i18n.translation.tools.plural },
    { title: i18n.translation.common.extras },
  ];

  return (
    <Tabs.SubTab>
      <Tabs
        urlParameter="h_items"
        tabs={tabs}
        contents={[
          <Towers active={(active ?? true) && selectedIndex === 0} />,
          <Trolleys active={(active ?? true) && selectedIndex === 1} />,
          <WaterproofKits active={(active ?? true) && selectedIndex === 2} />,
          <Rails active={(active ?? true) && selectedIndex === 3} />,
          <RailCurves active={(active ?? true) && selectedIndex === 4} />,
          <RailJunctions active={(active ?? true) && selectedIndex === 5} />,
          <RailTerminals active={(active ?? true) && selectedIndex === 6} />,
          <Screws active={(active ?? true) && selectedIndex === 7} />,
          <Tools active={(active ?? true) && selectedIndex === 8} />,
          <ItemExtras active={(active ?? true) && selectedIndex === 9} />,
        ]}
      />
    </Tabs.SubTab>
  );
};
